import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';



const firebaseConfig = {
  apiKey: "AIzaSyA5Rli21DoyvnuoBKX7SaW9tLn0phDqxIU",
  authDomain: "lernvent-tester-page.firebaseapp.com",
  projectId: "lernvent-tester-page",
  storageBucket: "lernvent-tester-page.appspot.com",
  messagingSenderId: "802029392631",
  appId: "1:802029392631:web:830218538749ea844e39f2"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase services
const auth = getAuth(app);
const db = getFirestore(app);

export { app, auth, db };